import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Our Mission", path: "/mission" },
    { name: "Our Team", path: "/team" },
    { name: "Events", path: "/events" },
    { name: "Gallery", path: "/gallery" },
    { name: "Annual Reports", path: "/annual-reports" },
    { name: "Donate", path: "/donate" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-[#F9F8F6]/80 backdrop-blur-xl border-b border-[#E4E2DC]">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/dwcan3p2_PAHADLOGO.jpeg" 
              alt="PAHAD Organics"
              className="h-16 w-16 object-contain"
            />
            <div>
              <h1 className="text-2xl font-heading font-semibold text-[#1C221F]">PAHAD TRUST</h1>
              <p className="text-xs text-[#515E58] uppercase tracking-wider">Hill Area Development</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? "text-[#2B5C45] border-b-2 border-[#2B5C45] pb-1"
                    : "text-[#515E58] hover:text-[#2B5C45]"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-[#F0EFEB] transition-colors"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-[#1C221F]" />
            ) : (
              <Menu className="h-6 w-6 text-[#1C221F]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden overflow-hidden"
            >
              <div className="py-4 space-y-2">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                      isActive(item.path)
                        ? "bg-[#2B5C45] text-white"
                        : "text-[#515E58] hover:bg-[#F0EFEB]"
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Header;
